import { Headset, Mail } from "lucide-react";
import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const FooterVariacaoVD = React.memo(() => {
  // const socialLinks = [
  //   {
  //     href: "https://www.facebook.com/thopenergy/",
  //     label: "Facebook",
  //     icon: <FaFacebook color="#fff" className="w-6 h-6" />,
  //   },
  //   {
  //     href: "http://linkedin.com/company/thopenergy",
  //     label: "Linkedin",
  //     icon: <FaLinkedin color="#fff" className="w-6 h-6" />,
  //   },
  //   {
  //     href: "http://instagram.com/thopenergy",
  //     label: "Instagram",
  //     icon: (
  //       <img
  //         src="/tim/images/instagram-logo.svg"
  //         alt="Instagram"
  //         width={24}
  //         height={24}
  //         loading="lazy"
  //       />
  //     ),
  //   },
  //   {
  //     href: "https://www.youtube.com/@thopenergy/",
  //     label: "Youtube",
  //     icon: <FaYoutube color="#fff" className="w-6 h-6" />,
  //   },
  // ];

  const year = new Date().getFullYear();

  return (
    <footer className="w-screen px-[20px] xl:px-[120px] py-16  bg-terciary-color justify-center items-center gap-2.5 flex">
      <div className="w-full max-w-[85rem] justify-center items-center gap-10 lg:gap-5 flex flex-col lg:flex-row">
        <div className="flex flex-col md:flex-row gap-6 md:gap-20 w-full items-start">
          {/* Logos */}
          <div className="flex justify-start items-center gap-6">
            <LogoLink
              href="https://thopenergy.com.br/"
              src="/tim/images/logos/logo_topen_white.webp"
              alt="Logo Thopen"
              width={110}
              height={30}
            />
          </div>
          <div className="flex flex-col gap-8 w-full">
            {/* Contact Information */}
            <div className="flex flex-col gap-6 lg:gap-4">
              <h2 className="font-bold text-base text-white text-start ">
                Fale conosco
              </h2>
              <div className="flex flex-col lg:flex-row gap-4 md:gap-10">
                <div className="flex items-center gap-3">
                  <Mail color="#fff" size={22} />
                  <span className="text-base font-normal text-neutral-100">
                    contato@thopenergy.com.br
                  </span>
                </div>
                <div className="flex items-center gap-3">
                  <Headset color="#fff" size={22} />
                  <span className="text-base font-normal text-neutral-100">
                    SAC (11) 4000-2022
                  </span>
                </div>
                <a
                  href="https://wa.me/551148633465"
                  className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-200"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Fale com o atendente"
                >
                  <FaWhatsapp color="#fff" size={22} />
                  <span className="text-base font-normal text-neutral-100">
                    Fale com o atendente
                  </span>
                </a>
              </div>
            </div>

            {/* Copyright - Desktop */}
            <span className="text-base font-normal text-neutral-100 text-start flex gap-3 leading-8">
              © copyright {year} Thopen Energy
              <span className="hidden md:inline">|</span>
              <br className="block md:hidden " />© TIM S/A. Todos os direitos
              reservados.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
});

// Componentes auxiliares memoizados para melhorar a performance
const LogoLink = React.memo(({ href, src, alt, width, height }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="hover:opacity-80 transition-opacity duration-200"
    aria-label={alt}
  >
    <img
      src={src || "/placeholder.svg"}
      alt={alt}
      width={width}
      height={height}
      loading="lazy"
    />
  </a>
));

const SocialLink = React.memo(({ href, label, children }) => (
  <a
    href={href}
    className="hover:opacity-80"
    target="_blank"
    rel="noopener noreferrer"
    alt={label}
    aria-label={label}
  >
    {children}
  </a>
));

const ContactItem = React.memo(({ children, extraClasses }) => (
  <div className={`flex gap-3 items-center text-nowrap  ${extraClasses}`}>
    {children}
  </div>
));

FooterVariacaoVD.displayName = "FooterVariacao";
LogoLink.displayName = "LogoLink";
SocialLink.displayName = "SocialLink";
ContactItem.displayName = "ContactItem";

export default FooterVariacaoVD;
